// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ClientRouteInteractFailCheckEvent
 */
export var ClientRouteInteractFailCheck = function (_a) {
    var origin = _a.origin, isDeepLink = _a.isDeepLink, specName = _a.specName, specPathFormat = _a.specPathFormat, specParameters = _a.specParameters, notAllowedReason = _a.notAllowedReason;
    return ({
        name: "ClientRoute Interact FailCheck",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "Interact",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_deep_link: isDeepLink !== undefined && isDeepLink !== null ? isDeepLink.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spec_name: specName !== undefined && specName !== null ? specName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spec_path_format: specPathFormat !== undefined && specPathFormat !== null ? specPathFormat.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spec_parameters: specParameters !== undefined && specParameters !== null ? specParameters.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            not_allowed_reason: notAllowedReason !== undefined && notAllowedReason !== null ? notAllowedReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteInteractRouteEvent
 */
export var ClientRouteInteractRoute = function (_a) {
    var origin = _a.origin, isDeepLink = _a.isDeepLink, specName = _a.specName, specPathFormat = _a.specPathFormat;
    return ({
        name: "ClientRoute Interact Route",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "Interact",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_deep_link: isDeepLink !== undefined && isDeepLink !== null ? isDeepLink.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spec_name: specName !== undefined && specName !== null ? specName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spec_path_format: specPathFormat !== undefined && specPathFormat !== null ? specPathFormat.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteInteractHandleKnownUnsupportedEvent
 */
export var ClientRouteInteractHandleKnownUnsupported = function (_a) {
    var specName = _a.specName, isSupportedOnLatestVersion = _a.isSupportedOnLatestVersion;
    return ({
        name: "ClientRoute Interact HandleKnownUnsupported",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "Interact",
            spec_name: specName !== undefined && specName !== null ? specName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_supported_on_latest_version: isSupportedOnLatestVersion !== undefined && isSupportedOnLatestVersion !== null ? isSupportedOnLatestVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteDeepLinkLaunchEvent
 */
export var ClientRouteDeepLinkLaunch = function (_a) {
    var url = _a.url, source = _a.source, canOpen = _a.canOpen;
    return ({
        name: "ClientRoute DeepLink Launch",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "DeepLink",
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_open: canOpen !== undefined && canOpen !== null ? canOpen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteDeepLinkHandleEvent
 */
export var ClientRouteDeepLinkHandle = function (_a) {
    var url = _a.url, source = _a.source, isDeferred = _a.isDeferred, isHandled = _a.isHandled;
    return ({
        name: "ClientRoute DeepLink Handle",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "DeepLink",
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_deferred: isDeferred !== undefined && isDeferred !== null ? isDeferred.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_handled: isHandled !== undefined && isHandled !== null ? isHandled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteDeepLinkHandleDeferredEvent
 */
export var ClientRouteDeepLinkHandleDeferred = function (_a) {
    var url = _a.url, source = _a.source, isSuceessful = _a.isSuceessful;
    return ({
        name: "ClientRoute DeepLink HandleDeferred",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "DeepLink",
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_suceessful: isSuceessful !== undefined && isSuceessful !== null ? isSuceessful.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ClientRouteDeepLinkHandleKnownUnsupportedEvent
 */
export var ClientRouteDeepLinkHandleKnownUnsupported = function (_a) {
    var specName = _a.specName, isSupportedOnLatestVersion = _a.isSupportedOnLatestVersion, isExternalBrowserFallback = _a.isExternalBrowserFallback;
    return ({
        name: "ClientRoute DeepLink HandleKnownUnsupported",
        parameters: {
            cdf_entity: "ClientRoute",
            cdf_action: "DeepLink",
            spec_name: specName !== undefined && specName !== null ? specName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_supported_on_latest_version: isSupportedOnLatestVersion !== undefined && isSupportedOnLatestVersion !== null ? isSupportedOnLatestVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_external_browser_fallback: isExternalBrowserFallback !== undefined && isExternalBrowserFallback !== null ? isExternalBrowserFallback.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
